module.exports = __webpack_public_path__ + "img/header.936c2b8.jpg";